import React from 'react';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import List, { DataFetcher } from './List';

interface Props {
    onInsertGraphicFuncName: string;
    currentDesignId: string;
    customerId: number | null;
    guestId: number | null;
    showGraphicUpload: () => void;
}

const GraphicsLibrary: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const {
        onInsertGraphicFuncName,
        currentDesignId,
        customerId,
        guestId,
        showGraphicUpload,
    } = props;

    const {
        data: graphics,
        allCount,
        customFilter,
        failed: loadFailed,
        loading,
    } = useTypedSelector((state) => state.graphicLibrary.loadGraphics);

    const dataFetcher: DataFetcher = (filter, page, pageSize, sort) => {
        dispatch(
            actions.loadGraphics(
                filter,
                page,
                pageSize,
                sort,
                customerId,
                guestId
            )
        );
    };

    return (
        <>
            <List
                dataFetcher={dataFetcher}
                data={{
                    graphics,
                    loadFailed,
                    allCount,
                    loadCounter: loading ? 1 : 0,
                    customFilter,
                }}
                defaultSort={{ id: 'dateAdd', desc: true }}
                onInsertGraphicFuncName={onInsertGraphicFuncName}
                currentDesignId={currentDesignId}
                customerId={customerId}
                guestId={guestId}
                showGraphicUpload={showGraphicUpload}
            />
        </>
    );
};

export default GraphicsLibrary;
